// File: /src/components/dashboard/ActivitiesPanel.js

import React from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { FaBell } from 'react-icons/fa';

const ActivitiesPanel = ({ activities, loading }) => (
	<div className="activities-container">
		<div className="activities-header">
			<div className="card-icon">
				<FaBell size={16} />
			</div>
			<h2>Atividades Recentes</h2>
		</div>
		{loading ? (
			<p>Carregando logs...</p>
		) : (
			<ul>
				{activities.map((activity) => (
					<li key={activity.id}>
						<span className="activity-text">{activity.text}</span>
						<span className="activity-date">
							{format(
								new Date(activity.date),
								"dd 'de' MMMM 'de' yyyy, HH:mm:ss",
								{ locale: ptBR }
							)}
						</span>
					</li>
				))}
			</ul>
		)}
	</div>
);

export default ActivitiesPanel;
